// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid.issues {
  grid-template-columns: repeat(9, auto);
}
.resolved {
  background-color: #8e9bb5;
}
.resolve {
  color: #54a54e !important;
}
.crits {
  background-color: #fffb8a;
}
.grid.filters {
  grid-template-columns: repeat(4, auto);
}
.grid.qa-issues {
  grid-template-columns: repeat(11, auto);
}
`, "",{"version":3,"sources":["webpack://./src/app/issue-tracker/issue-list/issue-list.component.less"],"names":[],"mappings":"AAEA;EACI,sCAAA;AADJ;AAIA;EACI,yBAAA;AAFJ;AAKA;EACI,yBAAA;AAHJ;AAKA;EACI,yBAAA;AAHJ;AAKA;EACI,sCAAA;AAHJ;AAKA;EACI,uCAAA;AAHJ","sourcesContent":["@import (reference) url('../../../styles.less');\n\n.grid.issues {\n    grid-template-columns: repeat(9, auto);\n}\n\n.resolved {\n    background-color: @grey;\n}\n\n.resolve {\n    color: @green !important;\n}\n.crits {\n    background-color: rgb(255, 251, 138);\n}\n.grid.filters {\n    grid-template-columns: repeat(4, auto);\n}\n.grid.qa-issues {\n    grid-template-columns: repeat(11, auto);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
